import React, {Component} from "react";
import CmModal from "../../../../components/CmModal/CmModal";
import CmForm from "../../../../components/CmForm/CmForm";
import {Form, Input, Select} from "antd";
import ConfigTreeSelect from "../configTreeSelect/ConfigTreeSelect";
import {message} from "../../utils/sysManagementUtils";
import ConfigValue from "./components/ConfigValue/ConfigValue";
import IsEnable from "./components/IsEnable/IsEnable";
import TypeSelect from "../typeSelect/TypeSelect";
import {validateName} from "../../../../utils";

const {TextArea} = Input;
const FormItem = Form.Item;
const { Option } = Select;

function _validateName(value, {min, max, includesZhCN = true} = {}) {
    let reg;
    if (includesZhCN) {
        reg = new RegExp(`^[\u9FA6-\u9FCB\u3400-\u4DB5\u4E00-\u9FA5\u25CF\u00B7_a-zA-Z0-9\.]{${min},${max}}$`);
    } else {
        reg = new RegExp(`^[_a-zA-Z0-9\.]{${min},${max}}$`);
    }
    return reg.test(value);
}

export default class ConfigTreeEditModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editData: null,
        };
    }

    componentDidUpdate = (prevProps, prevState, snapshot) => {
        if (this.props.visible&&this.props.visible !== prevProps.visible) {
            this.setState({
                editData: this.initData(this.props.data || {})
            });
        }
    };

    render() {
        const {
            visible
        } = this.props;

        const {editData} = this.state;

        if (!editData) {
            return null;
        }

        const isCreate = !editData.id.value;
        const onDataChange = this.onDataChange;

        return (
            <CmModal
                title={isCreate ? "添加配置" : "修改配置"}
                visible={visible}
                handleCancel={this.handleCancel}
                handleOk={this.handleOk}
                okText="提交"
                destroyOnClose={true}
            >
                <CmForm>
                    <FormItem
                        required={editData.configCategoryId.required}
                        label={editData.configCategoryId.label}
                    >
                        <ConfigTreeSelect
                            flag={visible}
                            placeholder={editData.configCategoryId.placeholder}
                            value={editData.configCategoryId.value}
                            onChange={configCategoryId => onDataChange({configCategoryId})}
                            checkStrictly={true}
                            onItemDelete={configCategoryId => onDataChange({configCategoryId: ""})}
                        />
                    </FormItem>

                    <FormItem
                        required={editData.configName.required}
                        label={editData.configName.label}
                    >
                        <Input
                            placeholder={editData.configName.placeholder}
                            value={editData.configName.value}
                            onChange={e => onDataChange({configName: e.target.value})}
                        />
                    </FormItem>

                    <FormItem
                        required={editData.configType.required}
                        label={editData.configType.label}
                    >
                        <TypeSelect
                            placeholder={editData.configType.placeholder}
                            value={editData.configType.value}
                            onChange={configType => {
                                onDataChange({configType, configValue: ""});
                            }}
                            disabled={!isCreate}
                        />
                    </FormItem>

                    <FormItem
                        required={editData.configKey.required}
                        label={editData.configKey.label}
                    >
                        <Input
                            placeholder={editData.configKey.placeholder}
                            value={editData.configKey.value}
                            onChange={e => onDataChange({configKey: e.target.value})}
                            disabled={!isCreate}
                        />
                    </FormItem>


                    <FormItem
                        required={editData.configValue.required}
                        label={editData.configType.value === 5 ? "开/关" : editData.configValue.label}

                    >
                        <ConfigValue
                            placeholder={editData.configValue.placeholder}
                            configValue={editData.configValue.value}
                            configType={editData.configType.value}
                            onChange={configValue => onDataChange({configValue})}
                        />
                    </FormItem>

                    <FormItem
                        required={editData.isEnable.required}
                        label={editData.isEnable.label}
                    >
                        <IsEnable
                            value={editData.isEnable.value}
                            onChange={isEnable => onDataChange({isEnable})}
                        />
                    </FormItem>
                    <FormItem
                        required={editData.securityLevel.required}
                        label={editData.securityLevel.label}
                    >
                        <Select value={editData.securityLevel.value} style={{width: 120}}
                                onChange={securityLevel => this.onDataChange({securityLevel: securityLevel})}>
                            <Option value={1} title={'系统配置不可修改'}>一级</Option>
                            <Option value={2} title={'自定义配置可修改'}>二级</Option>
                            <Option value={3} title={'未登录可查询配置'}>三级</Option>
                        </Select>
                    </FormItem>
                    <FormItem
                        required={editData.remark.required}
                        label={editData.remark.label}
                    >
                        <TextArea
                            placeholder={editData.remark.placeholder}
                            rows={4}
                            value={editData.remark.value}
                            onChange={e => onDataChange({remark: e.target.value})}
                            onKeyDown={e => e.stopPropagation()}
                        />
                    </FormItem>
                </CmForm>
            </CmModal>
        );
    }

    onDataChange = data => {
        const editData = this.state.editData;
        Object.keys(data).forEach(key => {
            editData[key].value = data[key];
        });
        this.setState({});
    };

    handleOk = () => {
        const {editData} = this.state;
        const data = {};
        const editDataKeys = Object.keys(editData);
        // console.log('editDataKeys-------------',editDataKeys);
        for (let i = 0; i < editDataKeys.length; i++) {
            const key = editDataKeys[i];
            data[key] = editData[key].value;
            if (editData[key].check && !editData[key].check(editData[key].value)) {
                return;
            }
        }
        console.log('data--------',data);
        this.props.handleOk(data);
    };

    handleCancel = () => {
        this.setState({
            editData: null
        });
        this.props.handleCancel();
    };

    initData = (
        {
            id = "",
            configName = "",
            configKey = "",
            configValue = "",
            isEnable = 1,
            configType = 6,
            remark = "",
            configCategoryId = "",
            securityLevel = 2,
        } = {}
    ) => {
        console.log("data init");
        const editData = {
            id: {
                value: id
            },
            configCategoryId: {
                value: configCategoryId,
                label: "栏目",
                required: true,
                placeholder: "请选择栏目",
                check: value => {
                    if (!value) {
                        message.error("请选择栏目");
                        return false;
                    }
                    return true;
                }
            },
            configName: {
                value: configName,
                label: "名称",
                required: true,
                placeholder: "请输入名称",
                check: value => {
                    if (!value) {
                        message.error("名称不能为空");
                        return false;
                    }
                    if (!validateName(value, {min: 2, max: 18})) {
                        message.error("配置名称为2-18个字，可使用中文、数字、字母、下划线");
                        return false;
                    }
                    return true;
                }
            },
            configType: {
                value: configType,
                label: "类型",
                required: true,
                placeholder: "请选择类型",
                check: value => {
                    if (!value) {
                        message.error("类型不能为空");
                        return false;
                    }
                    return true;
                }
            },
            configKey: {
                value: configKey,
                label: "code",
                required: true,
                placeholder: "请输入编码",
                check: value => {
                    if (!value) {
                        message.error("编码不能为空");
                        return false;
                    }
                    if (!_validateName(value, {min: 2, max: 50, includesZhCN: false})) {
                        message.error("编码为2-50个字字符，可使用数字、字母、英文句号、下划线");
                        return false;
                    }
                    return true;
                }
            },
            configValue: {
                value: configValue,
                label: "值",
                required: true,
                placeholder: "请输入值",
                check: value => {
                    if (!value) {
                        message.error("值不能为空");
                        return false;
                    }
                    return true;
                }
            },
            isEnable: {
                value: !!isEnable,
                label: "是否启用"
            },
            securityLevel: {
                value: securityLevel,
                label: "安全级别"
            },
            remark: {
                value: remark,
                placeholder: "请输入备注",
                label: "备注"
            }
        };
        return editData;
    };
}

